/**
 * Layout drawer component
 * 
 */
 
import React, { PureComponent } from 'react';

// Components

import Logo from '../../../components/logo/logo';
import Social from '../../../components/social/social';

// Javascript

import DrawerJs from '../../../assets/js/drawer';

export default class Drawer extends PureComponent {

	constructor(props) {

		super(props);
		
    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
		
		event.preventDefault();
		
		const target = event.currentTarget;
		const panel = document.getElementById(target.getAttribute('aria-controls'));

		DrawerJs.transition(panel, 'close');
	}

	render() {
		
		const { children, settings } = this.props;

		if (settings) {

			const { company_drawer_logo } = settings;

			return (

				<div className="layout-drawer" id="layout-drawer" aria-hidden="true">

					<div className="head">

						<Logo data={company_drawer_logo}></Logo>
						<button type="button" className="button button-close" data-toggle="#layout-drawer" aria-controls="layout-drawer" onClick={this.handleClick}><i className="icon i-close i-2x">Close panel</i></button>

					</div>
					<div className="body">

						<div className="social">
							<Social className="nav-social-drawer" data={settings}></Social>
						</div>

						{children}

					</div>

				</div>
			);
		}
		else {

			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/drawer/drawer.js